//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'FVC_EyeChart',

  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/FVC_EyeChart.vue